import { render, staticRenderFns } from "./Ctask-info.vue?vue&type=template&id=4da7628a&"
import script from "./Ctask-info.vue?vue&type=script&lang=js&"
export * from "./Ctask-info.vue?vue&type=script&lang=js&"
import style0 from "./Ctask-info.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports